import { combineReducers } from "redux";
import appReducer from "./appReducer";
import financeReducer from './financeReducer'
import projectReducer from './projectReducer'
import rolesReducer from './rolesReducer'
import vendorReducer from "./vendorReducer";
import userReducer from "./userReducer";
import customerReducer from "./customerReducer";
import leadSourceReducer from "./leadSourceReducer";
import snagDetailsReducer from "./snagDetailsReducer";
import productionSummaryProjectReducer from "./productionSummaryProjectReducer";
import panelDeliveryReportsReducer from "./panelDeliveryReportsReducer";
import marketingAdsReducer from "./marketingAdsReducer";

export default combineReducers({
    app: appReducer,
    finance: financeReducer,
    project: projectReducer,
    roles: rolesReducer,
    vendor: vendorReducer,
    user: userReducer,
    customer: customerReducer,
    leadSource: leadSourceReducer,
    snagDetails: snagDetailsReducer,
    productionSummaryProject: productionSummaryProjectReducer,
    panelDeliveryReports: panelDeliveryReportsReducer,
    marketingAds: marketingAdsReducer,
});
